import {Theme} from '@material-ui/core/styles';

export const getDirectionStyles = <T = any>(direction: Theme['direction']) => (
    ltrStyles: T,
    rtlStyles: T
): T => {
    return direction === 'ltr' ? ltrStyles : rtlStyles;
};

export const conditionalStyles = <T = any>(condition: boolean) => (styleA: T, styleB: T): T => {
    return condition ? styleA : styleB;
};
